import React from 'react';
import classnames from 'classnames'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Formik, Form, Field } from "formik";
import { Translate, withLocalize } from 'react-localize-redux';
import { mergeInto } from '../../../store/storeFunctions';
import { apiPost, getHostApi } from '../../../store/apiWrapper';
import { writeErr } from '../../common/logger';
import { domainActions } from '../../../store/domainStore';
import BbInput from '../../styling/bbInput';
import Message from "../../common/message";
import { validateInput } from '../../../store/storeFunctions';
const defaultValues = {
    companyName: "",
    companyId: "",
    refEmail: "",
    notes: ""
}

const requestStatus = {
    new: 1,
    submitting: 2,
    submitted: 3,
    failed: 4,
    partiallySubmitted: 5
};

class QuickReportFinDataUpdatePopup extends React.Component {
    state = { requestStatus: requestStatus.new }

    render() {
        if (this.state.requestStatus === requestStatus.submitting)
            return <div className="search-progress searching" style={{ width: "100%" }} />
        if (this.requestSent(this.state.requestStatus)) {
            const msg = this.getMessage(this.state.requestStatus);
            return (
                <div className="column is-12">
                    <div className="columns is-centered">
                        <div className="column is-12">
                            <Message type={msg.msgType} message={this.props.translate(msg.msg)} />
                        </div>
                    </div>
                </div>
            );
        }
        return this.renderForm();
    }

    renderForm = () => {
        return (
            <div>
                <Formik
                    onSubmit={(values) => this.submitSearch(values)}
                    initialValues={mergeInto({ ...defaultValues }, this.props.data.formData)}
                    enableReinitialize={true}
                >
                    {({ setFieldValue, values }) => (
                        <Form noValidate className="w-100">
                            <BbInput type="text" name="companyName" label={this.props.translate("Report.Quick.FinDataUpdate.Form.CompanyName")} placeholder={{ type: 'column' }} />
                            <BbInput type="text" name="companyId" label={this.props.translate("Report.Quick.FinDataUpdate.Form.CompanyId")} placeholder={{ type: 'column' }} />
                            <BbInput type="text" name="refEmail" label={this.props.translate("Report.Quick.FinDataUpdate.Form.RefEmail")} placeholder={{ type: 'column' }} />
                            <div className="italic-text" style={{ fontSize: "0.875em", textAlign: "right", marginTop: "-1.5em", marginRight: "0.40em", color: "#8d949e" }}>
                                <Translate id="Report.Quick.FinDataUpdate.Form.RefEmail2" />
                            </div>
                            <BbInput type='custom' name='notes' label={<Translate id="Report.Quick.FinDataUpdate.Form.Notes" />} placeholder={{ type: 'jumping' }} custom={
                                <Field component="textarea" name="notes" className="input" style={{ minHeight: "4em", minWidth: "100%" }} onInput={(e) => validateInput(e)} />
                            } />
                            <div className="modal-inner-buttons">
                                <button className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} type="submit">
                                    <Translate id="Report.Quick.FinDataUpdate.Form.Send" />
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        );
    }

    submitSearch = (values) => {
        this.setState({ requestStatus: requestStatus.submitting })
        apiPost(
            `${getHostApi()}/api/report/${this.props.data.entityId}/quick-report-fin-data-update/request`,
            {},
            values,
            (success) => {
                if (success.error.code === 200)
                    this.setState({ requestStatus: requestStatus.submitted });
                else if (success.error.code === 207)
                    this.setState({ requestStatus: requestStatus.partiallySubmitted });
                else
                    this.setState({ requestStatus: requestStatus.failed });
            },
            (error) => {
                writeErr(error);
                this.setState({ requestStatus: requestStatus.failed });
            }
        )
    }

    getMessage = (status) => {
        switch (status) {
            case requestStatus.submitted: return { msg: "Report.Quick.FinDataUpdate.Form.Success", msgType: "success" };
            case requestStatus.partiallySubmitted: return { msg: "Report.Quick.FinDataUpdate.Form.PartialSuccess", msgType: "warning" };
            case requestStatus.failed: return { msg: "Report.Quick.FinDataUpdate.Form.Failure", msgType: "error" };
            default: return null;
        }
    }

    requestSent = (status) => status === requestStatus.failed || status === requestStatus.submitted || status === requestStatus.partiallySubmitted;
}

export default withLocalize(QuickReportFinDataUpdatePopup);